/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Grower_File_Detach_ErrorInputs */

const vi_toast_grower_file_detach_error = /** @type {(inputs: Toast_Grower_File_Detach_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gỡ giấy tờ thất bại`)
};

/**

* @param {Toast_Grower_File_Detach_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_grower_file_detach_error = /** @type {((inputs?: Toast_Grower_File_Detach_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Grower_File_Detach_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_grower_file_detach_error(inputs)
});